/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpenWeaknessCountSnapshot
 */
export interface OpenWeaknessCountSnapshot {
    /**
     * 
     * @type {number}
     * @memberof OpenWeaknessCountSnapshot
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenWeaknessCountSnapshot
     */
    critical?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenWeaknessCountSnapshot
     */
    high?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenWeaknessCountSnapshot
     */
    medium?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenWeaknessCountSnapshot
     */
    low?: number;
}

/**
 * Check if a given object implements the OpenWeaknessCountSnapshot interface.
 */
export function instanceOfOpenWeaknessCountSnapshot(value: object): value is OpenWeaknessCountSnapshot {
    return true;
}

export function OpenWeaknessCountSnapshotFromJSON(json: any): OpenWeaknessCountSnapshot {
    return OpenWeaknessCountSnapshotFromJSONTyped(json, false);
}

export function OpenWeaknessCountSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenWeaknessCountSnapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'critical': json['critical'] == null ? undefined : json['critical'],
        'high': json['high'] == null ? undefined : json['high'],
        'medium': json['medium'] == null ? undefined : json['medium'],
        'low': json['low'] == null ? undefined : json['low'],
    };
}

export function OpenWeaknessCountSnapshotToJSON(json: any): OpenWeaknessCountSnapshot {
    return OpenWeaknessCountSnapshotToJSONTyped(json, false);
}

export function OpenWeaknessCountSnapshotToJSONTyped(value?: OpenWeaknessCountSnapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'critical': value['critical'],
        'high': value['high'],
        'medium': value['medium'],
        'low': value['low'],
    };
}

